import { autoRegisterFeature } from '@store/features/factory';

import { encounterTypesFeature } from './store/feature';

// Auto-register the feature (keeping original name for API compatibility)
autoRegisterFeature(encounterTypesFeature);

// Export everything
export * from './components';
export * from './constants';
export * from './hooks';
export * from './store';
export * from './types';
export { canMutateAppointmentType, getApiErrorMessage } from './utils/permissions';
export {
  resolveVisitMode,
  formatVisitModeLabel,
  type VisitModality,
  type ResolvedVisitMode,
} from './utils/visitMode';
